import React from 'react';
import { useSelector } from 'react-redux';
import { selectActivityContentLocale } from 'component/page/detail/store/detail.selectors';
import { Box, Divider, Grid, GridItem, Typography } from '@drone-js/core';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { GenericContent } from 'gql/autogen/GenericContent';

export interface SimCardContentProps {
    content: GenericContent;
    index: number;
    maxItems: number;
}

export const SimCardContent: React.FC<SimCardContentProps> = (props) => {
    const { content, index, maxItems } = props;
    const contentLocale = useSelector(selectActivityContentLocale);
    return (
        <>
            <Grid key={index} spacing="12" fluid={true}>
                <GridItem lg={4} md={4} sm={4}>
                    <Box p="12" display="flex">
                        <Typography key={index} lang={contentLocale} textColor="base.subtle" variant="body-s" tag="span">
                            <AgodaMarkdown key={index} dataElementName="sim-card-title" input={content?.title || ''} />
                        </Typography>
                    </Box>
                </GridItem>
                <GridItem lg={8} md={8} sm={8}>
                    <Box p="12" display="flex">
                        <Typography key={index} lang={contentLocale} variant="body-s-strong" tag="span">
                            <AgodaMarkdown dataElementName="sim-card-description" input={content?.description || ''} />
                        </Typography>
                    </Box>
                </GridItem>
            </Grid>
            {maxItems - 1 !== index && <Divider direction="horizontal" my="4" />}
        </>
    );
};
SimCardContent.displayName = 'SimCardContent';
